(function() {
  'use strict';

  function initGoatContest(root) {
    if (!root || root.dataset.goatContestInitialized === 'true') return;
    root.dataset.goatContestInitialized = 'true';

    // State
    const state = {
      currentStep: 1,
      name: '',
      mobile: '',
      email: '',
      city: '',
      quizAnswers: {
        q1: null,
        q2: null,
        q3: null
      },
      currentQuestionIndex: 1,
      totalQuestions: 3,
      quizScore: 0,
      orderId: '',
      orderVerified: false,
      entryId: makeEntryId()
    };

    // Stable per-visit id so the sheet updates one row per participant
    // instead of appending a new row at every funnel stage.
    function makeEntryId() {
      if (window.crypto && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
      }
      return 'kt-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    }

    // DOM Elements
    const stepperFill = root.querySelector('.kt-goat-stepper-progress-fill');
    const stepItems = root.querySelectorAll('.kt-goat-step-item');
    const panels = root.querySelectorAll('.kt-goat-panel');

    // Step 1 Form
    const step1Form = root.querySelector('#kt-goat-step1-form');
    const inputName = root.querySelector('#goat-name');
    const inputMobile = root.querySelector('#goat-mobile');
    const inputEmail = root.querySelector('#goat-email');
    const inputCity = root.querySelector('#goat-city');

    if (inputMobile) {
      inputMobile.addEventListener('input', function() {
        this.value = this.value.replace(/[^0-9+]/g, '');
        if (this.value.includes('+')) {
          this.value = '+' + this.value.replace(/\+/g, '');
        }
      });
    }

    // Step 2 Quiz
    const quizWraps = root.querySelectorAll('.kt-goat-question-wrap');
    const quizCounter = root.querySelector('#goat-quiz-counter');
    const quizNextBtn = root.querySelector('#goat-quiz-next-btn');
    const quizScoreReveal = root.querySelector('#goat-quiz-score-reveal');
    const quizScoreText = root.querySelector('#goat-quiz-score-text');

    // Step 3 Actions
    const step3ContinueBtn = root.querySelector('#goat-step3-continue-btn');
    const orderInput = root.querySelector('#goat-order-id');
    const verifyBtn = root.querySelector('#goat-verify-btn');
    const orderError = root.querySelector('#goat-order-error');
    const verifyApiUrl = root.dataset.verifyApiUrl || '';

    // Google Sheet (Apps Script) endpoint
    const webhookUrl = (root.dataset.webhookUrl || '').trim();
    const webhookToken = (root.dataset.webhookToken || '').trim();

    // Step 4 Summary
    const summaryName = root.querySelector('#summary-name');
    const summaryCity = root.querySelector('#summary-city');
    const summaryScore = root.querySelector('#summary-score');
    const summaryOrder = root.querySelector('#summary-order');
    const summaryStatus = root.querySelector('#summary-status');

    // Stepper updates
    function setStep(stepNum) {
      state.currentStep = stepNum;

      // Update stepper visual fill
      const fillPercentages = { 1: '0%', 2: '33.3%', 3: '66.6%', 4: '100%' };
      if (stepperFill) stepperFill.style.width = fillPercentages[stepNum] || '0%';

      stepItems.forEach(item => {
        const itemStep = parseInt(item.dataset.step, 10);
        item.classList.remove('is-active', 'is-completed');
        if (itemStep === stepNum) {
          item.classList.add('is-active');
        } else if (itemStep < stepNum) {
          item.classList.add('is-completed');
        }
      });

      // Toggle Panels
      panels.forEach(panel => {
        const pStep = parseInt(panel.dataset.panelStep, 10);
        panel.classList.toggle('is-active', pStep === stepNum);
      });

      // Smooth scroll to contest top
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Step 1 Validation & Submit
    if (step1Form) {
      step1Form.addEventListener('submit', function(e) {
        e.preventDefault();
        let isValid = true;

        // Reset errors
        root.querySelectorAll('.kt-goat-input-group').forEach(grp => grp.classList.remove('has-error'));

        // Validate Full Name
        const nameVal = inputName.value.trim();
        if (nameVal.length < 2) {
          inputName.closest('.kt-goat-input-group').classList.add('has-error');
          isValid = false;
        }

        // Validate Mobile (trim country code +91 / 0 / 91 to 10-digit number, minimum 10 digits)
        let mobileClean = inputMobile.value.replace(/\D/g, '');
        if (mobileClean.length > 10) {
          mobileClean = mobileClean.slice(-10);
        }
        if (mobileClean.length < 10 || !/^[6-9]\d{9}$/.test(mobileClean)) {
          inputMobile.closest('.kt-goat-input-group').classList.add('has-error');
          isValid = false;
        }

        // Validate Email
        const emailVal = inputEmail.value.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(emailVal)) {
          inputEmail.closest('.kt-goat-input-group').classList.add('has-error');
          isValid = false;
        }

        // Validate City
        const cityVal = inputCity.value.trim();
        if (cityVal.length < 2) {
          inputCity.closest('.kt-goat-input-group').classList.add('has-error');
          isValid = false;
        }

        if (isValid) {
          state.name = nameVal;
          state.mobile = mobileClean;
          state.email = emailVal;
          state.city = cityVal;

          // Adds the email to Shopify's customer list (email + name only —
          // Shopify strips everything else from a storefront customer form).
          syncToShopifyCustomers();

          // Full record goes to the sheet. Sent here too so participants who
          // drop off after Step 1 are still captured.
          pushToSheet('step1_lead');

          setStep(2);
          showQuestion(1);
        }
      });
    }

    // Step 2: Quiz Logic
    function showQuestion(qNum) {
      state.currentQuestionIndex = qNum;

      quizWraps.forEach(wrap => {
        const wrapQ = parseInt(wrap.dataset.questionIndex, 10);
        wrap.classList.toggle('is-active', wrapQ === qNum);
      });

      if (quizCounter) {
        quizCounter.textContent = 'Question ' + qNum + ' of ' + state.totalQuestions;
      }

      if (quizNextBtn) {
        if (qNum === state.totalQuestions) {
          quizNextBtn.innerHTML = '<span>SUBMIT QUIZ &rarr;</span>';
        } else {
          quizNextBtn.innerHTML = '<span>NEXT &rarr;</span>';
        }

        // Disable until an option is picked for this question
        const qKey = 'q' + qNum;
        quizNextBtn.disabled = !state.quizAnswers[qKey];
      }
    }

    // Option Selection
    root.querySelectorAll('.kt-goat-option-card').forEach(optionCard => {
      optionCard.addEventListener('click', function() {
        const parentQ = optionCard.closest('.kt-goat-question-wrap');
        const qIndex = parentQ.dataset.questionIndex;
        const qKey = 'q' + qIndex;
        const val = optionCard.dataset.val;

        // Deselect others in same question
        parentQ.querySelectorAll('.kt-goat-option-card').forEach(c => c.classList.remove('is-selected'));
        optionCard.classList.add('is-selected');

        state.quizAnswers[qKey] = val;
        if (quizNextBtn) quizNextBtn.disabled = false;
      });
    });

    if (quizNextBtn) {
      quizNextBtn.addEventListener('click', function() {
        if (state.currentQuestionIndex < state.totalQuestions) {
          showQuestion(state.currentQuestionIndex + 1);
        } else {
          // Calculate score
          // Question 1 correct: 'argentina'
          // Question 2 correct: '2022'
          // Question 3 correct: '3_times'
          let score = 0;
          if (state.quizAnswers.q1 === 'argentina') score++;
          if (state.quizAnswers.q2 === '2022') score++;
          if (state.quizAnswers.q3 === '3_times') score++;

          state.quizScore = score;
          pushToSheet('quiz_done');

          // Reveal score briefly before proceeding
          if (quizScoreReveal && quizScoreText) {
            quizScoreText.textContent = score + '/' + state.totalQuestions + (score === 3 ? ' — Perfect GOAT IQ! ⚽🔥' : ' — Great Attempt!');
            quizScoreReveal.style.display = 'flex';
          }

          setTimeout(function() {
            setStep(3);
          }, 900);
        }
      });
    }

    // Step 3: Direct Entry Completion
    if (step3ContinueBtn) {
      step3ContinueBtn.addEventListener('click', function() {
        step3ContinueBtn.disabled = true;
        const originalText = step3ContinueBtn.innerHTML;
        step3ContinueBtn.innerHTML = '<span class="kt-goat-spinner"></span> <span>COMPLETING...</span>';

        state.orderId = 'Direct Collection Entry';
        state.orderVerified = true;

        if (summaryName) summaryName.textContent = state.name || '-';
        if (summaryCity) summaryCity.textContent = state.city || '-';
        if (summaryScore) summaryScore.textContent = state.quizScore + ' / ' + state.totalQuestions + (state.quizScore === 3 ? ' (100%)' : '');
        if (summaryStatus) summaryStatus.textContent = 'Registered ✓';
        if (summaryOrder) summaryOrder.textContent = 'Completed';

        pushToSheet('completed');

        setTimeout(function() {
          setStep(4);
          step3ContinueBtn.disabled = false;
          step3ContinueBtn.innerHTML = originalText;
        }, 500);
      });
    }

    // Step 3: Product Card AJAX Add to Cart
    root.querySelectorAll('.kt-goat-atc-btn, .kt-goat-add-to-cart-btn').forEach(function(cartBtn) {
      cartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const variantId = cartBtn.dataset.variantId;
        if (!variantId) return;

        const origHtml = cartBtn.innerHTML;
        cartBtn.disabled = true;
        cartBtn.innerHTML = '<span class="kt-goat-spinner"></span> <span>ADDING...</span>';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId, 10),
              quantity: 1
            }]
          })
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function(cartData) {
          cartBtn.innerHTML = '<span>ADDED ✓</span>';
          cartBtn.style.setProperty('background', '#16A34A', 'important');
          cartBtn.style.setProperty('color', '#FFFFFF', 'important');

          // Notify Shopify theme of updated cart
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
          document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: cartData } }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:add'));

          // Try to open theme cart drawer if present
          const drawerComponent = document.querySelector('cart-drawer-component');
          if (drawerComponent) {
            if (typeof drawerComponent.open === 'function') {
              drawerComponent.open();
            } else if (typeof drawerComponent.showDialog === 'function') {
              drawerComponent.showDialog();
            }
          }
          const drawerTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]') || document.querySelector('[data-testid="cart-icon"]') || document.querySelector('.header-actions__cart-icon');
          if (drawerTrigger && typeof drawerTrigger.click === 'function') {
            drawerTrigger.click();
          }

          setTimeout(function() {
            cartBtn.disabled = false;
            cartBtn.innerHTML = origHtml;
            cartBtn.style.removeProperty('background');
            cartBtn.style.removeProperty('color');
          }, 2200);
        })
        .catch(function(err) {
          console.error('[KT GOAT] Add to cart error:', err);
          cartBtn.disabled = false;
          cartBtn.innerHTML = '<span>TRY AGAIN</span>';
          setTimeout(function() {
            cartBtn.innerHTML = origHtml;
          }, 2000);
        });
      });
    });

    // Step 3: Order Verification (fallback if present)
    if (verifyBtn && orderInput) {
      verifyBtn.addEventListener('click', function() {
        const orderVal = orderInput.value.trim();
        if (orderError) orderError.style.display = 'none';

        if (orderVal.length < 3) {
          if (orderError) {
            orderError.textContent = 'Please enter a valid Order ID (e.g. #KT10582 or 10582).';
            orderError.style.display = 'block';
          }
          return;
        }

        // Button Loading state
        verifyBtn.disabled = true;
        const originalText = verifyBtn.innerHTML;
        verifyBtn.innerHTML = '<span class="kt-goat-spinner"></span> <span>VERIFYING...</span>';

        // Backend hook: If verifyApiUrl is provided, call backend / app proxy
        if (verifyApiUrl && verifyApiUrl.trim() !== '') {
          fetch(verifyApiUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              order_id: orderVal,
              email: state.email,
              mobile: state.mobile,
              name: state.name
            })
          })
          .then(res => res.json())
          .then(data => {
            if (data.valid || data.success) {
              handleVerificationSuccess(orderVal, true);
            } else {
              throw new Error(data.message || 'Order ID could not be validated. Please check and try again.');
            }
          })
          .catch(err => {
            verifyBtn.disabled = false;
            verifyBtn.innerHTML = originalText;
            if (orderError) {
              orderError.textContent = err.message || 'Error verifying order. Please try again.';
              orderError.style.display = 'block';
            }
          });
        } else {
          // No verification API configured: the Order ID is accepted as-is and
          // flagged unverified in the sheet so entries can be checked manually.
          setTimeout(function() {
            handleVerificationSuccess(orderVal, false);
          }, 700);
        }
      });
    }

    function handleVerificationSuccess(orderVal, verified) {
      state.orderId = orderVal.startsWith('#') ? orderVal : ('#' + orderVal);
      state.orderVerified = verified === true;

      // Populate Step 4 Summary
      if (summaryName) summaryName.textContent = state.name || '-';
      if (summaryCity) summaryCity.textContent = state.city || '-';
      if (summaryScore) summaryScore.textContent = state.quizScore + ' / ' + state.totalQuestions + (state.quizScore === 3 ? ' (100%)' : '');
      if (summaryOrder) summaryOrder.textContent = state.orderId;

      // The Shopify customer was already created at Step 1; resubmitting the
      // same email is a no-op, so only the sheet gets the completed record.
      pushToSheet('completed');

      setStep(4);
    }

    function pushToSheet(stage) {
      if (!webhookUrl) {
        console.warn('[KT GOAT] No webhook URL set in the section settings — lead not saved.');
        return;
      }

      const payload = {
        token: webhookToken,
        entry_id: state.entryId,
        stage: stage,
        name: state.name,
        mobile: state.mobile,
        email: state.email,
        city: state.city,
        quiz_score: state.quizScore,
        quiz_total: state.totalQuestions,
        quiz_answers: [state.quizAnswers.q1, state.quizAnswers.q2, state.quizAnswers.q3]
          .map(function(a) { return a || '-'; })
          .join(' | '),
        order_id: state.orderId,
        order_verified: state.orderVerified,
        page_url: window.location.href,
        timestamp: new Date().toISOString()
      };

      try {
        fetch(webhookUrl, {
          method: 'POST',
          mode: 'no-cors',
          // text/plain keeps this a simple request, so the browser sends no CORS
          // preflight — Apps Script cannot answer an OPTIONS request. The script
          // still reads the raw JSON from e.postData.contents.
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload),
          keepalive: true
        }).catch(function(err) {
          console.warn('[KT GOAT] Sheet sync failed:', err);
        });
      } catch (err) {
        console.warn('[KT GOAT] Sheet sync error:', err);
      }
    }

    function syncToShopifyCustomers() {
      const syncForm = root.querySelector('#kt-goat-shopify-customer-sync');
      if (!syncForm) return;

      const nameParts = (state.name || '').trim().split(' ');
      const firstName = nameParts[0] || '';
      const lastName = nameParts.slice(1).join(' ') || firstName;

      const fNameInput = syncForm.querySelector('#shopify-sync-fname');
      const lNameInput = syncForm.querySelector('#shopify-sync-lname');
      const emailInput = syncForm.querySelector('#shopify-sync-email');

      if (fNameInput) fNameInput.value = firstName;
      if (lNameInput) lNameInput.value = lastName;
      if (emailInput) emailInput.value = state.email;

      // Posts into the hidden iframe so the page does not navigate. The
      // response is not readable from here, so treat this as best-effort:
      // the Google Sheet is the record of truth for contest entries.
      syncForm.submit();
    }
  }

  function hideFeaturedSections() {
    document.querySelectorAll('h1, h2, h3, h4, .scrolling-promotion__heading, .scrolling-promotion, .miday-feature').forEach(function(el) {
      if (el.classList.contains('miday-feature') || el.classList.contains('scrolling-promotion') || (el.textContent && el.textContent.trim().toLowerCase().includes('featured in'))) {
        var sec = el.closest('.shopify-section') || el.closest('section') || el;
        if (sec) sec.style.setProperty('display', 'none', 'important');
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      hideFeaturedSections();
      document.querySelectorAll('[data-kt-goat-contest]').forEach(initGoatContest);
    });
  } else {
    hideFeaturedSections();
    document.querySelectorAll('[data-kt-goat-contest]').forEach(initGoatContest);
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function(e) {
    hideFeaturedSections();
    const contestRoot = e.target.querySelector('[data-kt-goat-contest]');
    if (contestRoot) initGoatContest(contestRoot);
  });
})();
